<template>
  <div v-show="showTit === '公司概况'">
    <p
      class="nothing-tips"
      v-if="
        affairQuery &&
        makeDataShow &&
        overviewQuery &&
        !executivesData &&
        !makeData &&
        !reviewData &&
        !overviewData
      "
    >
      暂无数据
    </p>
    <section class="main" v-if="overviewData">
      <!-- 公司资料 -->
      <hgroup class="mainPage gsjj gszl">
        <header>公司资料</header>
        <div class="flex contract">
          <dl class="gsjj-contract">
            <dt>
              {{
                overviewData.gszl && overviewData.gszl.COMPNAME
                  ? overviewData.gszl.COMPNAME
                  : ""
              }}
            </dt>
            <dd>
              {{
                overviewData.gszl && overviewData.gszl.OFFICEADDR
                  ? overviewData.gszl.OFFICEADDR
                  : ""
              }}
            </dd>
          </dl>
          <a href="JavaScript:;" class="btn-gray" @click="digShow = !digShow"
            >联系方式</a
          >
        </div>
        <div class="block-card card-quote" v-if="overviewData.zyld">
          {{ overviewData.zyld ? overviewData.zyld : "" }}
        </div>
        <table class="table table-col2 table-gbgd" width="100%">
          <tr v-if="overviewData.gszl && overviewData.gszl.HSILEVEL2NAME">
            <td>所属行业</td>
            <td @click="goFs(overviewData.sshy.bkdm)">
              <a href="JavaScript:;">{{
                overviewData.gszl && overviewData.gszl.HSILEVEL2NAME
                  ? overviewData.gszl.HSILEVEL2NAME
                  : ""
              }}</a>
              <span :class="bkFs | zygdColor" v-if="bkFs"
                >（{{ bkFs | bkfsText }}）</span
              >
            </td>
          </tr>
          <tr v-if="overviewData.gszl && overviewData.gszl.CHAIRMAN">
            <td>董事长</td>
            <td>
              {{
                overviewData.gszl && overviewData.gszl.CHAIRMAN
                  ? overviewData.gszl.CHAIRMAN
                  : ""
              }}
            </td>
          </tr>
          <tr v-if="overviewData.dydgd">
            <td>第一大股东</td>
            <td>
              <span
                style="display: block"
                v-for="(item, index) in overviewData.dydgd"
                :key="index"
              >
                {{ item.gdmc }}
                <span class="ft-gray">（持有{{ item.cgzb }}%）</span>
              </span>
            </td>
          </tr>
          <tr v-if="overviewData.jbzl && overviewData.jbzl.ssrq">
            <td>上市时间</td>
            <td>
              {{
                overviewData.jbzl && overviewData.jbzl.ssrq
                  ? overviewData.jbzl.ssrq
                  : ""
              }}
            </td>
          </tr>
          <tr v-if="overviewData.jbzl && overviewData.jbzl.fxjg">
            <td>发行价格</td>
            <td>
              {{
                overviewData.jbzl && overviewData.jbzl.fxjg
                  ? gains(overviewData.jbzl.fxjg, "港元")
                  : ""
              }}
            </td>
          </tr>
          <tr v-if="overviewData.jbzl && overviewData.jbzl.fxl">
            <td>发行量</td>
            <td>
              {{
                overviewData.jbzl && overviewData.jbzl.fxl
                  ? overviewData.jbzl.fxl
                  : ""
              }}
            </td>
          </tr>
          <tr v-if="overviewData.jbzl && overviewData.jbzl.ssbk">
            <td>上市板块</td>
            <td>
              {{
                overviewData.jbzl && overviewData.jbzl.ssbk
                  ? overviewData.jbzl.ssbk
                  : ""
              }}
            </td>
          </tr>
          <tr v-if="overviewData.gszl && overviewData.gszl.WORKFORCE">
            <td>员工人数</td>
            <td>
              {{
                overviewData.gszl && overviewData.gszl.WORKFORCE
                  ? overviewData.gszl.WORKFORCE
                  : ""
              }}
            </td>
          </tr>
          <tr v-if="overviewData.gszl && overviewData.gszl.COMPINTRO">
            <td>公司简介</td>
            <td>
              <strong class="split-line3" v-show="!gsjsShow">{{
                overviewData.gszl && overviewData.gszl.COMPINTRO
                  ? overviewData.gszl.COMPINTRO
                  : ""
              }}</strong>
              <strong class="split-line3" v-show="gsjsShow">
                {{
                  overviewData.gszl &&
                  overviewData.gszl.COMPINTRO &&
                  overviewData.gszl.COMPINTRO.length > 40
                    ? overviewData.gszl.COMPINTRO.substr(0, 40) + "..."
                    : overviewData.gszl.COMPINTRO
                }}
              </strong>
              <span
                class="timeLine-open"
                v-if="overviewData.gszl.COMPINTRO.length >= 40"
                @click="gsjsShow = !gsjsShow"
                >{{ gsjsShow ? "展开" : "收起" }}</span
              >
            </td>
          </tr>
          <tr v-if="overviewData.gszl && overviewData.gszl.MAJORBIZ">
            <td>主营业务</td>
            <td>
              <strong class="split-line3" v-show="!jorbizShow">{{
                overviewData.gszl && overviewData.gszl.MAJORBIZ
                  ? overviewData.gszl.MAJORBIZ
                  : ""
              }}</strong>
              <strong class="split-line3" v-show="jorbizShow">
                {{
                  overviewData.gszl &&
                  overviewData.gszl.MAJORBIZ &&
                  overviewData.gszl.MAJORBIZ.length > 40
                    ? overviewData.gszl.MAJORBIZ.substr(0, 40) + "..."
                    : overviewData.gszl.MAJORBIZ
                }}
              </strong>
              <span
                class="timeLine-open"
                v-if="overviewData.gszl.MAJORBIZ.length >= 40"
                @click="jorbizShow = !jorbizShow"
                >{{ jorbizShow ? "展开" : "收起" }}</span
              >
            </td>
          </tr>
        </table>
      </hgroup>
      <!-- 主营构成 -->
      <hgroup class="mainPage zygc zygc-bd linkInside" v-if="makeData">
        <header>
          主营构成
          <span>{{ makeData ? makeData.time : null }}</span>
          <a :href="zylinkUrl">更多</a>
        </header>
        <div class="tab-sub-cont">
          <div class="canvas canvas-zlcc-all">
            <div class="fl canvas-circle">
              <div class="canvas-zygc-pie" id="zygcChart"></div>
            </div>
            <div class="canvas-info canvas-table-col3">
              <table class="table" width="100%">
                <tr>
                  <th>业务</th>
                  <th>营业收入</th>
                  <th>占比</th>
                </tr>
                <tr v-for="(item, index) in makeData.arr" :key="index">
                  <td>{{ item.pbacname }}</td>
                  <td>{{ item.fvalue }}</td>
                  <td>{{ item.fvalueRate }}%</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </hgroup>
      <!-- 高管资料 -->
      <hgroup class="mainPage gsgg" v-if="executivesData">
        <header>高管资料</header>
        <ul class="m-block">
          <li class="th">
            <span>名字</span>
            <span>职务</span>
            <span>任职日期</span>
            <span>性别</span>
          </li>
          <li
            v-for="(item, index) in executivesData.glcList"
            :key="index"
            @click="unfoldBtn(index)"
          >
            <div
              :class="
                executivesId.indexOf(index) !== -1 ? 'tr slideDown' : 'tr'
              "
            >
              <span>{{ item.PSNAME }}</span>
              <span>{{ item.DUTY }}</span>
              <span>{{ item.BEGINDATE }}</span>
              <span>{{ item.GENDER_N }}</span>
            </div>
            <div class="tr-more">{{ item.MEMO }}</div>
          </li>
        </ul>
      </hgroup>
      <!-- 业务回顾与展望 -->
      <hgroup class="mainPage ywhg" v-if="reviewData">
        <header>
          业务回顾与展望
          <span>{{ reviewData.ywhg.BGQ }}</span>
          <a :href="reviewData.moreUrl">更多</a>
        </header>
        <p class="text-box" v-html="reviewData.ywhg.C6"></p>
      </hgroup>
    </section>
    <Loading v-if="!affairQuery && !makeDataShow && !overviewQuery"></Loading>
    <declare
      v-if="
        affairQuery &&
        makeDataShow &&
        overviewQuery &&
        (executivesData || makeData || reviewData || overviewData)
      "
    ></declare>
    <div class="pop" v-if="digShow">
      <div class="pop-win pop-win-contract">
        <h6>联系方式</h6>
        <p>
          <span class="block" v-if="overviewData.gszl.COMPTEL"
            >联系电话&nbsp;&nbsp;{{
              overviewData.gszl.COMPTEL ? overviewData.gszl.COMPTEL : ""
            }}</span
          >
          <span class="block" v-if="overviewData.gszl.COMPURL"
            >公司官网&nbsp;&nbsp;{{
              overviewData.gszl.COMPURL ? overviewData.gszl.COMPURL : ""
            }}</span
          >
          <span class="block" v-if="overviewData.gszl.COMPEMAIL"
            >电子邮箱&nbsp;&nbsp;{{
              overviewData.gszl.COMPEMAIL ? overviewData.gszl.COMPEMAIL : ""
            }}</span
          >
        </p>
        <a class="pop-btn" @click="digShow = !digShow">确定</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getEventData, getYunToken } from "../api/index";
import mixins from "../mixins/index";
import Loading from "../components/loading";
import Declare from "../components/declare";
export default {
  name: "brief",
  props: ["showTit", "token"],
  data() {
    return {
      executivesId: [], //公司高管选中列表
      makeCur: 0,
      protocol: window.location.protocol,
      zylinkUrl: "", //主营构成更多跳转连接
      makeDataShow: false,
      affairQuery: false,
      overviewQuery: false, // 公司资料请求
      executivesData: null, //高管资料
      makeData: null, //主营构成
      reviewData: null, //业务回顾与展望
      overviewData: null, //公司信息
      myChart: null,
      linkUrl: "",
      jorbizShow: true, //主营业务展开收起
      gsjsShow: true, //公司介绍 展开收起

      digShow: false, // 弹框
      bkFs: null,
    };
  },
  mixins: [mixins],
  components: { Loading, Declare },
  watch: {
    showTit: {
      handler(newval, old) {
        if (newval === "公司概况" && !this.affairQuery) {
          this.code = this.getUrlQuery("code");
          let codeNum = this.getUrlQuery("code");
          // http://mnews-test.dzh.com.cn/wap/data/ipad/stock/HK/01/00001/f10//HK_F10_Sjtx_Max.html?DZHSPECIAL=1
          this.zylinkUrl =
            window.config.url +
            "/wap/data/ipad/stock/" +
            codeNum.substr(0, 2) +
            "/" +
            codeNum.substr(-2) +
            "/" +
            codeNum.substr(2) +
            "/f10/HK_F10_Zygc_Max.html?DZHSPECIAL=1";
          this.$nextTick(() => {
            this.getOverviewData();
            this.getAffairData();
            this.$nextTick(() => {
              this.getMakeData();
            });
          });
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    unfoldBtn: function (index) {
      if (this.executivesId.indexOf(index) === -1) {
        this.executivesId.push(index);
      } else {
        var index = this.executivesId.indexOf(index);
        this.executivesId.splice(index, 1);
      }
    },
    // 获取事件提醒数据
    getAffairData: function () {
      let that = this;
      let executivesKey = that.code + "-B8"; // 公司高管
      let reviewKey = that.code + "-B1-4"; // 业务回顾和展望
      let busiTypeArr = [executivesKey, reviewKey];
      let objs = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: busiTypeArr.join(),
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(objs), that.token)
        .then((res) => {
          that.affairQuery = true;
          if (res.resCode === "000000") {
            that.executivesData = res.resData.hasOwnProperty(executivesKey)
              ? res.resData[executivesKey]
              : null;
            that.reviewData = res.resData.hasOwnProperty(reviewKey)
              ? res.resData[reviewKey]
              : null;
          }
        })
        .catch(() => {
          that.affairQuery = true;
        });
    },
    // 主营业务
    getMakeData: function () {
      let that = this;
      var option = {
        color: ["#e25856", "#fd9946", "#fdbd43", "#ffc83a", "#ffe600"],
        tooltip: {
          formatter: "{b}",
          confine: true,
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: [],
          },
        ],
      };
      let objs = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: "mapdata/zygc/" + that.code + "/bd",
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(objs), that.token)
        .then((res) => {
          that.makeDataShow = true;
          if (res.resCode === "000000") {
            let data = res.resData.hasOwnProperty(objs.reqData.busiType)
              ? res.resData[objs.reqData.busiType]
              : null;
            let time = [];
            if (data) {
              for (let key in data) {
                time.push(key);
              }
              that.makeData = { time: time[0], arr: data[time[0]].slice(0, 3) };
              let arr = [];
              that.$nextTick(() => {
                if (data[time[0]] !== null && data[time[0]].length > 0) {
                  try {
                    let total = data[time[0]][0].biztotinco - 0;
                    let values = 0;
                    for (let i = 0; i < that.makeData.arr.length; i++) {
                      values += that.makeData.arr[i]["panVale"] - 0;
                      let obj = {};
                      obj.value = (
                        (that.makeData.arr[i]["panVale"] / total) *
                        100
                      ).toFixed(2);
                      obj.name = that.makeData.arr[i]["pbacname"];
                      arr.push(obj);
                    }
                    arr.push({
                      value: (((total - values) / total) * 100).toFixed(2),
                      name: "其他",
                    });
                    setTimeout(() => {
                      that.myChart = that.$echarts.init(
                        document.getElementById("zygcChart")
                      );
                      option.series[0].data = arr;
                      that.$nextTick(() => {
                        that.myChart.setOption(option);
                      });
                    }, 1000);
                  } catch (e) {
                    console.log(e);
                  }
                } else {
                  that.makeData = null;
                }
              });
            }
          }
        })
        .catch(() => {
          that.makeDataShow = true;
        });
    },
    // 获取公司概况
    getOverviewData: function () {
      let that = this;
      let zyldKey = "mapdata/gsgk/zyld/" + that.code; // 主要亮点
      let jbzlKey = "mapdata/gsgk/jbzl/" + that.code; // 上市信息
      let sshyKey = "mapdata/gsgk/sshy/" + that.code; // 所属行业
      let surveyKey = that.code + "-B7"; //获取主营业务
      let dydgdKey = "mapdata/gbgd/dydgd/" + that.code; // 第一大股东
      let busiTypeArr = [zyldKey, jbzlKey, sshyKey, surveyKey, dydgdKey];

      let objs = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: busiTypeArr.join(),
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(objs), that.token)
        .then((res) => {
          that.overviewQuery = true;
          if (res.resCode === "000000") {
            let obj = {
              gszl: res.resData[surveyKey] ? res.resData[surveyKey].gszl : null,
              zyld: res.resData[zyldKey] ? res.resData[zyldKey].zyld : null,
              jbzl: res.resData[jbzlKey] ? res.resData[jbzlKey].data : null,
              sshy: res.resData[sshyKey] ? res.resData[sshyKey].data : null,
              dydgd:
                res.resData[dydgdKey] && res.resData[dydgdKey].data.length
                  ? res.resData[dydgdKey].data
                  : null,
            };
            if (obj.gszl || obj.zyld || obj.jbzl || obj.sshy || obj.dydgd) {
              this.overviewData = obj;
            }
            if (obj.sshy) {
              this.getTokenYun(obj.sshy.bkdm);
            }
          }
        })
        .catch(() => {
          that.overviewQuery = true;
        });
    },

    // 获取云平台token
    getTokenYun: function (code) {
      let that = this;
      let obj = {
        appid: window.config.yunId,
        secret_key: window.config.yunkey,
      };
      getYunToken(obj).then((res) => {
        if (res.Err === 0 && res.Data.RepDataToken) {
          that.getStocksZf(res.Data.RepDataToken[0].token, code);
        }
      });
    },

    // 获取板块行情数据
    getStocksZf: function (token, code) {
      let that = this;
      code = "K$" + code;
      if (!this.websocket) {
        this.websocket = new WebSocket(
          `${window.config.wsurl}/ws?token=${token}`
        );
        this.websocket.onopen = () => {
          this.websocketSend(code);
        };
      } else {
        this.websocket.send(`/cancel?qid=1`);
        this.websocketSend(code);
      }
      this.websocket.onmessage = (evt) => {
        let fr = new FileReader();
        fr.readAsText(evt.data);
        fr.onload = () => {
          let result = JSON.parse(fr.result);
          let dynaList = result.Data.RepDataStkData;
          if (dynaList) {
            that.bkFs = dynaList[0].ZhangFu;
          }
        };
      };
      this.websocket.onclose = () => {
        this.websocket.close();
        this.websocket = null;
        this.getTokenYun();
      };
    },

    websocketSend(code) {
      this.websocket.send(
        `/stkdata?obj=${code}&field=ZhongWenJianCheng,JiaoYiDaiMa,ZuiXinJia,ZhangFu&qid=1&sub=1`
      );
    },
    goFs: function (code) {
      location.href = `dzh_browser_url&goto=0&type=2970&code=K$${code}&kind=0`;
    },
    maxSorting: function (arr) {
      var min;
      for (var i = 0; i < arr.length; i++) {
        for (var j = i; j < arr.length; j++) {
          if (arr[i] < arr[j]) {
            min = arr[j];
            arr[j] = arr[i];
            arr[i] = min;
          }
        }
      }
      return arr;
    },
  },
};
</script>
<style lang="less" scoped></style>
